import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth?.user?.IsLoginValid);
  const roleID = useSelector((state) => state?.auth?.user?.UserRoleID);
  const menu_list = useSelector((x) => x?.auth?.menu_list);
  // return isLoggedIn === 1 && roleID === 1 ? (
  //   <Navigate to="/Admin/FacilityList" replace />
  // ) : isLoggedIn === 1 && roleID === 2 ? (
  //   <Navigate to="/Admin/Dashboard" replace />
  // ) : isLoggedIn === 1 && roleID === 3 ? (
  //   <Navigate to="/Admin/Dashboard" replace />
  // ) : isLoggedIn === 1 && roleID === 6 ? (
  //   <Navigate to="/Admin/PostalMailList" replace />
  // ) : isLoggedIn === 1 && roleID === 10 ? (
  //   <Navigate to="/Admin/StaffRequestList" replace />
  // ) : isLoggedIn === 1 && roleID === 11 ? (
  //   <Navigate to="/Admin/StaffRequestList" replace />
  // ) : isLoggedIn === 1 && roleID === 12 ? (
  //   <Navigate to="/Admin/ManagementUserList" replace />
  // ) : isLoggedIn === 1 && roleID === 13 ? (
  //   <Navigate to="/Admin/Dashboard" replace />
  // ) : (
  //   children
  // );

  if (menu_list && menu_list.length > 0 && isLoggedIn === 1) {
    return (
      <Navigate
        to={roleID === 1 ? menu_list[0].URLPath : "/Admin/support"}
        replace
      />
    );
  } else if (menu_list && menu_list.length === 0 && isLoggedIn === 1) {
    return <Navigate to="/Admin/support" replace />;
  } else if (menu_list && menu_list.length === 0 && isLoggedIn === 0) {
    return <Navigate to="/facilityuser" replace />;
  }
  return children;
};

export default PublicRoute;
